import { defineComponent as _defineComponent } from 'vue'
import { message } from "ant-design-vue"
import { storeToRefs } from "pinia"
import { computed, ref, watch } from "vue"

import ProductCode from "@/components/Common/ProductCode"
import Thumbnail from "@/components/Common/Thumbnail"
import i18n from "@/i18n"
import { useSyncDraftsStore } from "@/modules/sync/store/useSyncDraftsStore"
import { useSyncOffersBindingStore } from "@/modules/sync/store/useSyncOffersBindingStore"
import { OfferListItem } from "@/types/offers.type"
import { SyncDraft } from "@/types/sync.type"
import getFormattedPrice from "@/utils/getFormattedPrice"
import getPriceWithCurrency from "@/utils/getPriceWithCurrency"
import getProductState from "@/utils/getProductState"
import makeQuery from "@/utils/makeQuery"

import { useApproveWindowColumns } from "./useApproveWindowColumns"

// Fix: Define dummy variables to hint types for Volar in legacy slot usage
// This is required because Volar cannot infer slot-scope types in usage of AntDV 1.x with script setup
type Props = {
  isOpened: boolean
  syncUuid: string
  payload: SyncDraft | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ApproveWindow',
  props: {
    isOpened: { type: Boolean },
    syncUuid: null,
    payload: null
  },
  emits: ["close", "approved"],
  setup(__props: any, { emit }) {

const props = __props as {
  isOpened: boolean
  syncUuid: string
  payload: SyncDraft | null
};

const record = {} as OfferListItem
// endFix

// Helper Types/Variables


// End Helper Types/Variables

// Store & Route
const syncOffersBindingStore = useSyncOffersBindingStore()
const syncDraftsStore = useSyncDraftsStore()

const { offers, fetching } = storeToRefs(syncOffersBindingStore)
// End Store & Route

// State
const currentFetching = ref("")
// End State

// Composables
const { columns } = useApproveWindowColumns()
// End Composables

// Computed
const pCode = computed(() => props.payload?.product?.p_code || "")
const slug = computed(() => props.payload?.product?.slug || "")
const price = computed(() => props.payload?.price || "")
const quantity = computed(() => props.payload?.quantity || 0)
const query = computed(() => {
  const result = {}

  if (Object.keys(props.payload).length) {
    result["condition_key"] = props.payload.condition_key

    // push 'condition_value' to query only when condition_key === used
    if (props.payload.condition_key === "used") {
      result["condition_value"] = props.payload.condition_value
    }

    result["delivery"] = props.payload.delivery.uuid
    result["warranty"] = props.payload.warranty
    result["product"] = props.payload.product.p_code
    result["ordering"] = "is_synced"
  }

  return result
})
// End Computed

// Methods
const parseStateDescription = (key, value) => {
  return getProductState(key, value)?.description
}
const handleTableChange = (pagination, filters, sorter) => {
  const queryParams = makeQuery({ filters, sorter })

  syncOffersBindingStore.getOffers({
    query: Object.assign({}, query.value, queryParams)
  })
}
const createNewOffer = () => {
  currentFetching.value = "createNewOffer"

  syncDraftsStore
    .updateDraft({
      payload: {
        _approve: true
      },
      synchronizationUuid: props.syncUuid,
      draftUuid: props.payload.uuid
    })
    .then((approvedDraft) => {
      message.success(i18n.t("synchronization.succesful_created") as string)
      emit("approved", approvedDraft)
    })
    .finally(() => {
      stopFetching()
    })
}
const handleConnect = (record) => {
  currentFetching.value = `connecting-${record.uuid}`

  syncDraftsStore
    .updateDraft({
      payload: {
        _approve: true,
        price: record.price,
        delivery: record.delivery.uuid,
        offer: record.uuid,
        warranty: record.warranty
      },
      synchronizationUuid: props.syncUuid,
      draftUuid: props.payload.uuid
    })
    .then((approvedDraft) => {
      message.success(i18n.t("synchronization.succesful_connected") as string)
      emit("approved", approvedDraft)
    })
    .finally(() => {
      stopFetching()
    })
}
const stopFetching = () => {
  currentFetching.value = ""
}
// End Methods

// Lifecycle
watch(
  () => props.isOpened,
  (bool) => {
    if (!bool) return

    syncOffersBindingStore.clearState()
    syncOffersBindingStore
      .getOffers({
        query: query.value
      })
      .then((results) => {
        if (results.count === 0) {
          createNewOffer()
        }
      })
  }
)
// End Lifecycle

return { __sfc: true,record, props, emit, syncOffersBindingStore, syncDraftsStore, offers, fetching, currentFetching, columns, pCode, slug, price, quantity, query, parseStateDescription, handleTableChange, createNewOffer, handleConnect, stopFetching, ProductCode, Thumbnail, getFormattedPrice, getPriceWithCurrency }
}

})